import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext';
import { Input } from 'alurkerja-ui';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';

export const specPengajuanLembur = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Durasi (Jam)',
    name: 'duration',
    type: 'number',
  },
];
export default function TotalJamLemburField() {
  const { watch, setValue, taskData } = useContext<CustomComponentContextType>(CustomComponentContext);
  const [hours, setHours] = useState(0);

  const endedDate = watch('ended_date');
  const startedDate = watch('started_date');

  useEffect(() => {
    if (moment(startedDate, 'YYYY-MM-DDTHH:mm', true).isValid() && moment(endedDate, 'YYYY-MM-DDTHH:mm', true).isValid()) {
      const date1 = moment(startedDate, 'YYYY-MM-DDTHH:mm');
      const date2 = moment(endedDate, 'YYYY-MM-DDTHH:mm');

      const duration = moment.duration(date2.diff(date1));
      const hours = duration.asHours();
      setHours(hours);
      setValue('duration', hours.toFixed(2));
    } else if ((moment(startedDate, 'YYYY-MM-DDTHH:mm', true).isValid() || moment(endedDate, 'YYYY-MM-DDTHH:mm', true).isValid()) && taskData?.variables) {
      const date1 = moment((startedDate != null && startedDate != '') ? startedDate : taskData.variables?.started_date, 'YYYY-MM-DDTHH:mm');
      const date2 = moment((endedDate != null && endedDate != '') ? endedDate : taskData.variables?.ended_date, 'YYYY-MM-DDTHH:mm');

      const duration = moment.duration(date2.diff(date1));
      const hours = duration.asHours();
      setHours(hours);
      setValue('duration', hours.toFixed(2));
    } else if (taskData) {
      const duration = parseFloat(taskData.variables?.duration);
      setHours(duration);
      setValue('duration', duration.toFixed(2));
    }
  }, [endedDate, startedDate, setValue, taskData]);

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium";

  return (
    <div>
      <label className={classNamesLabel} data-testid="label-id">Durasi (Jam)</label>
      <Input value={hours.toFixed(2)} disabled data-testid="input-id" />
    </div>
  );
}
